export const SNACKBAR_CARDS_DELETE_TEXT = 'multi_card_form_snackbar_delete_text';
export const SNACKBAR_CARDS_ARCHIVED_TEXT = 'snackbar.archive.multi.card.text';
